import React, { useMemo } from 'react';
import { HuchaVentaValues } from '../../shared/models/hucha-values';
import { Renovador10To15VouchersPopup } from '../components/popup/popup-hucha-renovadores-10-to-15';
import { RenovadorPlus15VouchersPopup } from '../components/popup/popup-hucha-renovadores-plus15';
import { HuchaStandardVouchersPopup } from '../components/popup/popup-hucha-standard';
import { PdfHuchaRenovadores10To15 } from '../components/pdf/pdf-hucha-renovadores-10-to-15';
import { PdfHuchaRenovadoresPlus15 } from '../components/pdf/pdf-hucha-renovadores-plus15';
import { PdfHuchaStandard } from '../components/pdf/pdf-hucha-standard';

export const useHuchaVentaLayerContent = (huchaValues: HuchaVentaValues) => {
	const huchaVentaPopupLayerContent = useMemo(() => {
		if (huchaValues?.huchaTier === 'standard') {
			return <HuchaStandardVouchersPopup huchaValues={huchaValues} />;
		}

		if (huchaValues?.huchaTier === 'renovador10To15') {
			return <Renovador10To15VouchersPopup huchaValues={huchaValues} />;
		}

		if (huchaValues?.huchaTier === 'renovadorPlus15') {
			return <RenovadorPlus15VouchersPopup huchaValues={huchaValues} />;
		}
		return null;
	}, [huchaValues]);

	const huchaVentaPdfLayerContent = useMemo(() => {
		if (huchaValues?.huchaTier === 'standard') {
			return <PdfHuchaStandard huchaValues={huchaValues} />;
		}

		if (huchaValues?.huchaTier === 'renovador10To15') {
			return <PdfHuchaRenovadores10To15 huchaValues={huchaValues} />;
		}

		if (huchaValues?.huchaTier === 'renovadorPlus15') {
			return <PdfHuchaRenovadoresPlus15 huchaValues={huchaValues} />;
		}
		return null;
	}, [huchaValues]);

	return { huchaVentaPopupLayerContent, huchaVentaPdfLayerContent };
};
